import { ProcessingMode } from "univapay-node";

import { sdk } from "../redux/sdk/SDK";

/**
 * @deprecated This function is used for 3DS mocks and will be removed once the service will be part of the API
 */
export const isTest = () => {
    try {
        return sdk.api.endpoint.startsWith("http://api.int");
    } catch (error) {
        return false;
    }
};

export const isTestProcessingMode = (mode: ProcessingMode) => mode !== ProcessingMode.LIVE;

/**
 * Used for conditionally running logic inside a component that should only be executed whilst running in TestCafe.
 * Please be aware that the `window.isTestCafe` flag must be set on the fixture for this to work.
 * For an example @see {@link /test/e2e/specs/widget/environment-confirmation-window.spec.ts}
 */
export const isTestCafe = window.IsTestCafe;
